<template>
  <section :id="currentCategory.id">
    <MixesStepHeader
      :name="currentCategory.name"
      :current-step="currentStepIndex"
    />
    <MixesGridCatalog
      :kind="kind"
      :ingredients="currentCategoryIngredients"
    />
  </section>
</template>

<script setup>
import { noop } from '@vueuse/core'
import { computed } from 'vue'

import MixesGridCatalog from '@/components/mixes/MixesGridCatalog.vue'
import MixesStepHeader from '@/components/mixes/MixesStepHeader.vue'

const props = defineProps({
  kind: {
    type: String,
    default: 'musli',
  },

  allIngredients: {
    type: Array,
    required: true,
    default: () => [],
  },

  currentCategory: {
    type: Object,
    required: true,
    default: noop,
  },

  currentStepIndex: {
    type: String,
    default: '1',
  },
})

const currentCategoryIngredients = computed(() => {
  return props.allIngredients.filter(({ parentCategoryId }) => props.currentCategory.id === parentCategoryId)
})
</script>
